<template>
  <m-dialog ref="nilaiDlg" :isclose="true" @save="save" :fullscreen="true" title="Nilai Peserta">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row wrap>
            <v-col cols="12" class="mt-5">
              <v-card flat>
                <v-card-title class="primary--text">Tambahkan nilai pada kolom nilai disetiap peserta</v-card-title>
                <v-card-text>
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-0 py-0">
                      <v-text-field
                        outlined
                        dense
                        autofocus
                        v-model="textSearch"
                        placeholder="Cari Pengguna berdasarkan nama"
                        hint
                        clearable
                        append-icon="mdi-magnify"
                        @click:append="search()"
                        @keyup.enter="search()"
                        @click:clear="search()"
                        persistent-hint
                        :error-messages="errors.collect('form.instansi')"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-data-table :headers="headers" :items="itemKandidats" :items-per-page="15" item-key="id" hide-default-footer>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id">
                              <td class="font-weight-bold">{{ pVal(item, "name") }}</td>
                              <td class="blue--text text--darken-4">{{ pVal(item, "email") }}</td>
                              <td>{{ pVal(item, "nama_sekolah") }}</td>
                              <td>
                                <v-text-field
                                  class="mt-2"
                                  data-vv-name="nilai"
                                  data-vv-as="Nilai"
                                  v-validate="'numeric'"
                                  outlined
                                  dense
                                  autofocus
                                  v-model="item.nilai_luring"
                                  placeholder="Masukkan Nilai"
                                  hint
                                  clearable
                                  persistent-hint
                                  :error-messages="errors.collect('form.diklat')"
                                ></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                        <template v-slot:footer>
                          <v-row wrap class="pb-3" v-if="page && page.last_page > 1">
                            <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 3" class="text-left" align="center" justify="center">
                              <p class="caption font-weight-bold">{{ page.total }} &nbsp; Data ditemukan</p>
                            </v-col>
                            <v-col cols="8" v-if="$vuetify.breakpoint.smAndUp" class="text-center">
                              <v-pagination v-if="page.total" :key="page_key" v-model="current_page" :length="page.last_page" :total-visible="7" @input="change"></v-pagination>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 9" v-if="page.from" class="text-right">
                              <p class="caption font-weight-bold">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row></v-card-text
                ></v-card
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      duplicate: false,
      enroll: {},
      tipe: "",
      course_id: null,
      modul_id: null,
      textSearch: "",
      itemKelases: [],
      itemKandidats: [],
      countMapelPilihan: 1,
      alert: ALERT_INFO,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      selection: [],
      pagging: {},
      page_key: 0,
      totalPagination: [],
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Surel", align: "left", value: "email" },
        { text: "Sekolah", align: "left", value: "nama_sekolah" },
        { text: "Nilai", align: "left", value: "nama_sekolah" }
      ]
    };
  },
  methods: {
    open() {
      this.course_id = null;
      this.textSearch = null;
      this.itemKelases = [];
      this.itemKandidats = [];
      this.page = null;
      this.loadKandidat();

      let x = this.$refs.nilaiDlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$confirm(`Apakah Anda yakin akan menyimpan hasil penilaian pada Kelas ini ?`)
            .then(() => {
              return this.$store
                .dispatch("kelas/inputNilai", {
                  instansi_id: this.instansi_id,
                  kelas_id: this.kelas_id,
                  obj: this.itemKandidats
                })
                .then(res => {
                  if (res.error) {
                    this.$error("Simpan penilaian Kelas gagal");
                  } else {
                    this.$info("Simpan penilaian kelas berhasil");
                    this.$refs.nilaiDlg.resolve();
                  }
                });
            })
            .catch(e => e);
        });
    },

    search() {
      this.current_page = 1;
      this.cp = 1;
      this.loadKandidat();
    },

    // eslint-disable-next-line
    loadKandidat() {
      return this.$store
        .dispatch("kelas/getPesertaKelas", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          params: {
            page: this.cp,
            s: this.textSearch,
            nilai: true
          }
        })
        .then(res => {
          this.page = res;
          this.itemKandidats = res.data;

          this.itemKandidats.forEach(kandidat => {
            kandidat.nilai_luring = kandidat.kelasenrol[0].nilai_luring;
          });
        })
        .catch(e => e);
    },

    change() {
      if (this.current_page !== this.page.current_page) {
        this.cp = this.current_page;
        this.loadKandidat();
      }
    }
  },
  watch: {
    course_id() {
      this.loadKandidat();
    },
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    items() {
      this.current_page = this.page ? this.page.current_page : 0;
    }
  }
};
</script>
